import { Component, Input } from '@angular/core';

import { BaseReportKpiComponent } from 'rev-shared/ui/reports/BaseReportKpi.Component';

@Component({
	selector: 'event-analytics-kpis',
	templateUrl: './EventAnalyticsKpis.Component.html',
	host: {
		layout: 'column',
		'layout-wrap': 'false'
	}
})
export class EventAnalyticsKpisComponent extends BaseReportKpiComponent {
	@Input() public readonly accountId: string;
}
